import './HomeReportsAndNews.styles.scss';
import { useHomeReportsAndNews } from "@apiHooks/useHomeReportsAndNews";
import HomeSectionHeader from "@pages/Home/components/HomeSectionHeader";
import HomeSectionTitle from "@pages/Home/components/HomeSectionTitle";
import HomeSectionLoader from "@pages/Home/components/HomeSectionLoader";
import HomeSectionDelimiter from "@pages/Home/components/HomeSectionDelimiter";
import cn from "classnames";
import { FCX, usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import { useEffect, useState } from "react";
import HomeReports from "@pages/Home/sections/HomeReportsAndNews/HomeReports";
import HomeSectionTabs from "@pages/Home/components/HomeSectionTabs";
import HomeNews from "@pages/Home/sections/HomeReportsAndNews/HomeNews";
import useLocalStorageState from "@hooks/useLocalStorageState";

const HomeReportsAndNews: FCX = () => {
    const isNewsEnabled = usePlatformFeatureFlag('SNAP home news');
    const { isLoading, data: rawData } = useHomeReportsAndNews();
    const [selectedTab, setSelectedTab] = useLocalStorageState<'reports' | 'news'>('home-reports-news-tab','news');
    const [bgSrc, setBgSrc] = useState('');

    useEffect(() => {
        if (!isNewsEnabled) {
            setSelectedTab('reports');
        }
    }, [isNewsEnabled]);

    return (
        <>
            <div
                className={cn(
                    "HomeReportsAndNews",
                    isLoading && "is-loading",
                )}
            >
                <div
                    key={bgSrc}
                    className="HomeReportsAndNews__bg"
                    style={{
                        backgroundImage: `url(${bgSrc})`,
                    }}
                />
                <div className="HomeReportsAndNews__overlay"/>
                <div className="HomeReportsAndNews__content">
                    <div className="HomeReportsAndNews__content-wrapper">
                        {!isLoading && (
                            <div>
                                <div
                                    className="Home__wrapper"
                                    style={{
                                        paddingBottom: 30,
                                        paddingTop: 60,
                                    }}
                                >
                                    <HomeSectionHeader>
                                        <HomeSectionTitle>
                                            {isNewsEnabled ? 'News & Reports' : 'Reports'}
                                        </HomeSectionTitle>
                                        {isNewsEnabled && (
                                            <HomeSectionTabs
                                                data={[
                                                    { id: 'news', title: 'News' },
                                                    { id: 'reports', title: 'Reports' },
                                                ]}
                                                activeTabId={selectedTab}
                                                onItemClick={(id) => setSelectedTab(id as 'reports' | 'news')}
                                            />
                                        )}
                                    </HomeSectionHeader>
                                </div>
                                <div className="Home__wrapper" style={{ padding: 0 }}>
                                    {selectedTab === 'news' && (
                                        <HomeNews
                                            data={rawData.news ?? []}
                                            setBgSrc={setBgSrc}
                                        />
                                    )}
                                    {selectedTab === 'reports' && (
                                        <HomeReports
                                            data={rawData.publications ?? []}
                                            setBgSrc={setBgSrc}
                                        />
                                    )}
                                </div>
                                <div className="Home__wrapper"
                                     style={{ paddingBottom: 30, opacity: 0, pointerEvents: 'none' }}>
                                    <HomeSectionHeader>
                                        <HomeSectionTitle>&nbsp;</HomeSectionTitle>
                                    </HomeSectionHeader>
                                </div>
                            </div>
                        )}
                        {isLoading && <HomeSectionLoader/>}
                    </div>
                </div>
            </div>
            <div className="Home__wrapper">
                <HomeSectionDelimiter colors={['#1DFEEC', '#4FB0F9', '#FF59B9', '#FF0395']}/>
            </div>
        </>
    );
}

export default HomeReportsAndNews;